/* eslint-disable */
// @ts-nocheck
//@ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Pangostack
 * SaaS Deployment Tool
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * The user that caused the activity, or null for system activities.
 * @export
 * @interface ActivityDtoCreatedBy
 */
export interface ActivityDtoCreatedBy {
    /**
     * The user ID from the auth provider.
     * @type {string}
     * @memberof ActivityDtoCreatedBy
     */
    id: string;
    /**
     * The display name.
     * @type {string}
     * @memberof ActivityDtoCreatedBy
     */
    name: string;
    /**
     * The email address.
     * @type {string}
     * @memberof ActivityDtoCreatedBy
     */
    email: string;
}

/**
 * Check if a given object implements the ActivityDtoCreatedBy interface.
 */
export function instanceOfActivityDtoCreatedBy(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "email" in value;

    return isInstance;
}

export function ActivityDtoCreatedByFromJSON(json: any): ActivityDtoCreatedBy {
    return ActivityDtoCreatedByFromJSONTyped(json, false);
}

export function ActivityDtoCreatedByFromJSONTyped(json: any, ignoreDiscriminator: boolean): ActivityDtoCreatedBy {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'email': json['email'],
    };
}

export function ActivityDtoCreatedByToJSON(value?: ActivityDtoCreatedBy | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'email': value.email,
    };
}

